import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { VppApplicationsReducer } from './vpp-applications.reducer';
import { VppApplicationsEffects } from './vpp-applications.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('vppApplications', VppApplicationsReducer),
    EffectsModule.forFeature([VppApplicationsEffects]),
  ],
  providers: [],
})
export class VppApplicationsStoreModule {}
